<template>
	<div class="drawer">
		<el-drawer size="1000px" title="变更记录" :visible.sync="drawerStatus" @close='close' :close-on-press-escape="false" :wrapperClosable="false" :modal-append-to-body="false" >
			<el-table :data="tableData">
				<el-table-column label="关联ID" width="150">
					<template slot-scope="scope">
						{{scope.row.link_id}}
					</template>
				</el-table-column>
				<!-- <el-table-column label="类型" width="130">
					<template slot-scope="scope">
						<span v-if="scope.row.link_type===1">顾客基本信息</span>
						<span v-if="scope.row.link_type===2">宠物基本信息</span>
						<span v-if="scope.row.link_type===3">顾客资产</span>
						<span v-if="scope.row.link_type===4">顾客成长值</span>
						<span v-if="scope.row.link_type===5">洗美卡</span>
						<span v-if="scope.row.link_type===6">优惠券</span>
						<span v-if="scope.row.link_type===7">消费订单</span>
						<span v-if="scope.row.link_type===8">充值订单</span>
						<span v-if="scope.row.link_type===9">退换货订单</span>
					</template>
				</el-table-column> -->
				<el-table-column label="变更内容" >
					<template slot-scope="scope">
						{{scope.row.update_content}}
					</template>
				</el-table-column>
				<el-table-column label="备注" width="200">
					<template slot-scope="scope">
						{{scope.row.remark}}
					</template>
				</el-table-column>
				<el-table-column label="操作人" width="100">
					<template slot-scope="scope">
						{{scope.row.update_user.user_name}}
					</template>
				</el-table-column>
				<el-table-column label="操作时间" width="150">
					<template slot-scope="scope">
						{{$public.FTime(scope.row.update_time)}}
					</template>
				</el-table-column>
			</el-table>
			<div style="height: 40px;width:100%;"></div>
			<!-- <div class="btnBox">
				<div class="btnItem" @click="close">取消</div>
				<div class="btnItem submit" @click="submit">确定</div>
			</div> -->
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				
				tableData:[],
			}
		},
		props:{
			linkId:{
				default:''
			},
			type:{   // 1:顾客信息变动 2:宠物信息变动 3:资产变动记录变动  4:成长值变动 5:洗美卡 6:优惠券 7:消费订单 8:充值订单 9:退换货订单 10:余额变动 11:积分变动 12:成长值变动记录变动
				default:0,
			}
		},
		computed:{
			
		},
		mounted(){
			this.$nextTick(()=>{
				this.drawerStatus=true;
			})
			this.getTableData();
		},
		methods:{
			close(){
				this.$emit("submit",{type:'close'})
			},
			getTableData(){
				let params = {
					"linkId": this.linkId,
					"type": this.type,   
					"pageIndex": 1,
					"pageSize": 300,
				}
				this.$http.get(process.env.VUE_APP_member+'/api/DataUpdateRecord/list', params).then(res => {
					if (res.code == 0) {
						this.tableData = res.data.data||[];
					}
				})
			},
		},
	}
</script>

<style scoped lang="scss">
	.drawer{
		.btnBox{
			width:100%;font-size: 14px;color:#fff;line-height: 40px;display: flex;position: absolute;bottom: 0;z-index: 10;
			.btnItem{
				text-align: center;width:100%;background-color: #D6D6D6;cursor: pointer;
				&.submit{
					background-color: #3569FF;
				}
			}
		}
	}
	
</style>

